<a routerLink="/admin/{{item.link}}">
    <mat-card>
        <img src="assets/menu/{{item.icon}}">
        <mat-card-content>
            {{item.title}}
        </mat-card-content>
    </mat-card>
</a>